<script setup lang="ts">
const props = defineProps({
  isActive: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>

<template>
  <div class="permission-entity-item" :class="{'is-active': isActive}">
    <div class="thumbnail" v-if="$slots.thumbnail">
      <slot name="thumbnail"/>
    </div>
    <div class="title">
      <slot/>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@toolify/client/src/styles/variables' as variables;

  .permission-entity-item {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: map-get(variables.$spacing, space-2);
    height: map-get(variables.$sizes, size-lg);
    padding: 0 map-get(variables.$spacing, space-2) 0 map-get(variables.$spacing, space-2);
    border-radius: map-get(variables.$radiuses, radius-lg);
    cursor: pointer;
  }

  .thumbnail, .title {
    display: flex;
    align-items: center;
  }
</style>
